import React, { useState } from "react";

export function SiteImage({
  src,
  alt,
  className = "",
  imageClassName = "",
  fallbackLabel = "Redland Golf & Country Club",
  sizes,
  priority,
}) {
  const [failed, setFailed] = useState(false);
  const resolved = src && src.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${src}` : src;

  return (
    <div className={`site-photo ${failed ? "site-photo-failed" : ""} ${className}`.trim()}>
      {!failed ? (
        <img
          src={resolved}
          alt={alt}
          loading={priority ? "eager" : "lazy"}
          className={`site-photo-img ${imageClassName}`.trim()}
          onError={() => setFailed(true)}
        />
      ) : null}
      <div className="site-photo-fallback" role="img" aria-label={alt}>
        <span>{fallbackLabel}</span>
      </div>
    </div>
  );
}
